<template>
  <div v-if="nodes">
    <div v-if="otherNodes">
      <product-block v-for="(item, index) in otherNodes" :key="index" :productInfo="item" />
    </div>
    <div v-if="downloadLinks" class="download-block" :class="additionalClass">
      <div class="download-block__inner">
        <download-links :links="downloadLinks" />
      </div>
    </div>
  </div>
</template>

<script>
  import ProductBlock from '~/components/product/ProductBlock.vue';
  import DownloadLinks from '~/components/product/DownloadLinks.vue';

  export default {
    name: 'DownloadOverview',
    components: {
      ProductBlock,
      DownloadLinks
    },
    computed: {
      downloadLinks() {
        const list = this.nodes.filter((item) => {
          return item.productBlockType === 'SystemOverview';
        });
        return list;
      },
      otherNodes() {
        const list = this.nodes.filter((item) => {
          return item.productBlockType !== 'SystemOverview';
        });
        return list;
      }
    },
    props: {
      additionalClass: {
        default: '',
        type: String
      },
      nodes: {
        default() {
          return [];
        },
        type: Array
      },
      // we get these props but don't use them in current block type
      items: {
        default() {
          return [];
        },
        type: Array
      },
      title: {
        default: '',
        type: String
      },
      content: {
        default() {
          return {};
        },
        type: Object
      },
      video: {
        default() {
          return {};
        },
        type: Object
      },
      placeholder: {
        default() {
          return {};
        },
        type: Object
      },
      images: {
        default() {
          return [];
        },
        type: Array
      }
    }
  };
</script>
